// import { Helmet, style } from "../Helmet";
import { Colors, Metrics, Typography } from "../../resources";
import { StyleSheet, Text, View } from "react-native";

import React from "react";
import STooltipBase from "./STooltipBase";

interface IProps {
  children: JSX.Element;
  placement?: any;
  title?: string | JSX.Element;
  content: string | JSX.Element;
}

const STooltip: React.FC<IProps> = ({
  title = undefined,
  placement = "bottom",
  children,
  content,
}) => {
  const renderContent = () => {
    return (
      <View style={styles.container}>
        {title !== undefined ? (
          <>
            <Text style={styles.title}>{title}</Text>
          </>
        ) : null}
        <Text style={styles.content}>{content}</Text>
      </View>
    );
  };

  return (
    <>
      <STooltipBase content={renderContent()} placement={placement}>
        {children}
      </STooltipBase>
    </>
  );
};
const styles = StyleSheet.create({
  container: {
    padding: 12,
    flex: 1,
    backgroundColor: Colors.midnight,
    borderRadius: 4,
    shadowColor: Colors.midnight80,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  title: {
    ...Typography.titleTooltip,
    textAlign: "left",
    color: Colors.white,
    marginBottom: Metrics.padding8,
  },
  content: {
    ...Typography.bodyTooltip,
    textAlign: "left",
    color: Colors.white,
    lineHeight: 14.4,
  },
});

export default STooltip;
